function initMobileMenuFixes() {
  const mobileMenu = document.getElementById('mobile-menu');
  const toggleButton = document.querySelector('.header__mobile-nav-toggle');
  const closeButton = document.querySelector('.mobile-menu__close');

  if (!mobileMenu) return;

  // Toggle menu open
  if (toggleButton) {
    toggleButton.onclick = function () {
      mobileMenu.setAttribute('aria-hidden', 'false');
      document.body.classList.add('mobile-menu--open');
    };
  }

  // Toggle menu close
  if (closeButton) {
    closeButton.onclick = function () {
      mobileMenu.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mobile-menu--open');
    };
  }

  // Panel open buttons
  document.querySelectorAll('[data-action="open-panel"]').forEach(trigger => {
    trigger.onclick = function (e) {
      e.preventDefault();
      const panelId = this.getAttribute('data-panel-id');
      const panel = document.getElementById(panelId);

      if (panel) {
        document.querySelectorAll('.mobile-menu__panel').forEach(p => {
          p.classList.remove('is-open', 'is-visible');
        });
        panel.classList.add('is-open', 'is-visible');
      }
    };
  });

  // Panel back buttons
  document.querySelectorAll('[data-action="back"]').forEach(back => {
    back.onclick = function (e) {
      e.preventDefault();
      const current = this.closest('.mobile-menu__panel');
      const parentId = current?.getAttribute('data-parent-panel-id');
      const parent = document.getElementById(parentId);
      
      if (current) current.classList.remove('is-open', 'is-visible');
      if (parent) parent.classList.add('is-open', 'is-visible');
    };
  });

  // Clicking any menu link closes menu
  document.querySelectorAll('#mobile-menu a').forEach(link => {
    link.onclick = function () {
      mobileMenu.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mobile-menu--open');
    };
  });
}

// Bind on load and Shopify page changes
document.addEventListener('DOMContentLoaded', initMobileMenuFixes);
document.addEventListener('page:load', initMobileMenuFixes);       // Turbo links or similar
document.addEventListener('shopify:section:load', initMobileMenuFixes); // Shopify sections

// Re-enable click events on collection pages
function enableMenuClicks() {
  if (!document.body.classList.contains('template-collection')) return;

  const menu = document.getElementById('mobile-menu');
  if (menu) {
    menu.style.pointerEvents = 'auto';
  }
  
  document.querySelectorAll('.mobile-menu__panel').forEach(panel => {
    panel.style.pointerEvents = 'auto';
  });
  
  document.querySelectorAll('.mobile-menu__nav-link, .mobile-menu__back-button').forEach(el => {
    el.style.pointerEvents = 'auto';
  });

  const toggle = document.querySelector('.header__mobile-nav-toggle');
  if (toggle) {
    toggle.style.pointerEvents = 'auto';
  }
}

// Run after content load
document.addEventListener('DOMContentLoaded', enableMenuClicks);
document.addEventListener('page:load', enableMenuClicks);
document.addEventListener('shopify:section:load', enableMenuClicks);
